export default function CtaSection() {
  const formUrl = 'https://readdy.ai/api/form/d9q1f3cnlsngrm4llq3g';

  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20warm%20gradient%20abstract%20background%20with%20soft%20golden%20bokeh%20light%20particles%2C%20elegant%20atmospheric%20glow%2C%20professional%20cinema%20style%2C%20rich%20deep%20warm%20tones%2C%20luxurious%20theater%20ambiance%2C%20clean%20refined%20composition&width=1600&height=800&seq=cta-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/50 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-4xl text-background-50 mb-4">
          精彩内容 · 即刻开启
        </h2>
        <p className="text-background-200 text-sm md:text-base mb-8 leading-relaxed">
          订阅爱液视频更新通知，第一时间获取最新精选视频资源，精彩不容错过！
        </p>

        <form
          className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
          data-readdy-form="d9q1f3cnlsngrm4llq3g"
          onSubmit={async (e) => {
            e.preventDefault();
            const form = e.currentTarget;
            const formData = new FormData(form);
            const hp = formData.get('phone_alt') as string;
            if (hp && hp.trim() !== '') {
              const msg = document.getElementById('cta-msg');
              if (msg) { msg.textContent = '订阅成功！感谢您的关注。'; msg.className = 'text-green-300 text-xs mt-3'; }
              form.reset();
              return;
            }
            try {
              const params = new URLSearchParams();
              formData.forEach((value, key) => {
                if (key !== 'phone_alt' || !(value as string).trim()) {
                  params.append(key, value as string);
                }
              });
              const res = await fetch(formUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: params.toString(),
              });
              const text = await res.text();
              let msgText = '';
              try {
                const p = JSON.parse(text);
                if (res.ok && p.code === 'OK') { msgText = '订阅成功！感谢您的关注。'; }
                else { msgText = p?.meta?.message || p?.message || '提交失败，请稍后再试'; }
              } catch { msgText = '提交失败，请稍后再试'; }
              const el = document.getElementById('cta-msg');
              if (el) {
                el.textContent = msgText;
                el.className = msgText.includes('成功') ? 'text-green-300 text-xs mt-3' : 'text-red-300 text-xs mt-3';
              }
              if (msgText.includes('成功')) form.reset();
            } catch {
              const el = document.getElementById('cta-msg');
              if (el) { el.textContent = '网络错误，请稍后再试'; el.className = 'text-red-300 text-xs mt-3'; }
            }
          }}
        >
          <input
            type="email"
            name="email"
            placeholder="请输入您的邮箱地址"
            required
            className="w-full sm:flex-1 px-5 py-3 rounded-full text-sm bg-background-50/15 border border-background-50/20 text-background-50 placeholder-background-300 outline-none focus:border-background-50/40"
          />
          <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="honeypot-field" />
          <button
            type="submit"
            className="w-full sm:w-auto px-8 py-3 bg-accent-500 hover:bg-accent-600 text-background-50 font-medium rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-send-plane-line mr-2"></i>
            立即订阅
          </button>
        </form>
        <p id="cta-msg" className="text-xs mt-3"></p>
      </div>
    </section>
  );
}